// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'

const uswitchLogo = {
  url: 'https://www.uswitch.com/',
  src: `https://img.uswitch.com/t014ej9w3ur1/6VZ4sEuz3n64ABR9LwSD0h/54b5ecea09117d186ee3e1aecd41d013/Union__2_.svg?auto=format&fit=fill&crop=faces%2Centropy&fill=solid&ixlib=react-8.6.4`,
  alt: 'Uswitch logo',
}

const moneyLogo = {
  url: 'https://www.money.co.uk/',
  src: `https://img.money.co.uk/t014ej9w3ur1/5hj3XP0JQ086GVWceveABu/4a231aded401f637d0c3d81b6c3c8983/logo.svg`,
  alt: 'Money logo',
}

const Header = ({ logo }) => {
  return (
    <div
      sx={{
        width: '100%',
        paddingTop: '0',
        paddingBottom: '0',
        boxSizing: 'border-box',
      }}
    >
      <div
        sx={{
          width: '100%',
          marginX: 'auto',
          paddingY: '8px',
          boxSizing: 'border-box',
          paddingLeft: '15px',
          paddingRight: '15px',
          maxWidth: '1200px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        <a
          href={logo.url}
          sx={{
            display: 'inline-block',
            marginY: ['3px', '9px'],
            height: ['24px', '33px'],
            width: ['95px', '130px'],
          }}
        >
          <img
            src={logo.src}
            alt={logo.alt}
            sx={{
              width: '100%',
              height: 'auto',
            }}
          />
        </a>
      </div>
    </div>
  )
}

export const UswitchHeader = () => {
  return <Header logo={uswitchLogo} />
}

export const MoneyHeader = () => {
  return <Header logo={moneyLogo} />
}
